var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
    _vm.products.length > 0
      ? _c(
          "div",
          { staticClass: "products" },
          _vm._l(_vm.products, function (product) {
            return _c("div", { staticClass: "prod_info" }, [
              _c(
                "div",
                {
                  staticClass:
                    "user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2 px-2 p-1",
                },
                [
                  _c("div", { staticClass: "d-flex flex-row pt-2 pb-1" }, [
                    _c("span", { staticClass: "status" }, [
                      _c("img", {
                        staticClass:
                          "profile-image rounded-circle d-inline-block",
                        attrs: { src: product.image },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "position-absolute remove",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.remove_item(product)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "btn btn-danger btn-sm btn-icon waves-effect waves-themed",
                          },
                          [_c("i", { staticClass: "fal fa-times" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    product.hasOwnProperty("has_override")
                      ? _c(
                          "span",
                          {
                            staticClass: "position-absolute override_settings",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-checkbox" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: product.has_override,
                                      expression: "product.has_override",
                                    },
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    name: "cid[]",
                                    type: "checkbox",
                                    id: product.id + "_cust_id",
                                  },
                                  domProps: {
                                    checked: Array.isArray(product.has_override)
                                      ? _vm._i(product.has_override, null) > -1
                                      : product.has_override,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = product.has_override,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                product,
                                                "has_override",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                product,
                                                "has_override",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(product, "has_override", $$c)
                                        }
                                      },
                                      function ($event) {
                                        return _vm.change_atr(product)
                                      },
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "custom-control-label cursor-pointer bolder",
                                    attrs: { for: product.id + "_cust_id" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.__t("HAS_OVERRIDE")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "user_attrib ml-3" }, [
                      _c(
                        "div",
                        { staticClass: "name d-block fw-700 text-dark" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(product.title) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "company small text-dark" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(product.price) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  product.has_override
                    ? _c(
                        "div",
                        { staticClass: "override_settings mt-2 mb-2" },
                        [
                          _c("info_field", {
                            attrs: {
                              f_uniq: "cid_min_over",
                              f_type: "min_qual",
                              is_disabled: false,
                              f_title: _vm.__t("MIN_QUAL"),
                              f_val: product.override.min,
                            },
                            on: {
                              update_categ: function (f_type, cur_val) {
                                return _vm.change_attr_override(
                                  f_type,
                                  cur_val,
                                  product
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("info_field", {
                            attrs: {
                              f_uniq: "cid_max_over",
                              f_type: "max_qual",
                              is_disabled: false,
                              f_title: _vm.__t("MAX_QUAL"),
                              f_val: product.override.max,
                            },
                            on: {
                              update_categ: function (f_type, cur_val) {
                                return _vm.change_attr_override(
                                  f_type,
                                  cur_val,
                                  product
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }